import { useState } from 'react'

export function useFirstMount(): boolean {
  const [firstMount, setFirstMount] = useState(true)

  if (firstMount) {
    setFirstMount(false)
    return true
  }

  return false
}
